import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { getDataTestAttribute } from "utils/dataTestAttribute";
import "./ContactDetails.scss";

const ContactDetails = ({ number, email, ...dataTest }) => {
	const dataTestAttribute = getDataTestAttribute(dataTest);
	return (
		<div className="contactDetails" {...dataTestAttribute}>
			{number && number.trim() !== "" && (
				<>
					<FontAwesomeIcon icon={faPhone} className="fa-2x" data-test-id="contact-details-phone-icon" />
					<h3 data-test-id="contact-details-phone">{number}</h3>
				</>
			)}
			{email && email.trim() !== "" && (
				<>
					<FontAwesomeIcon icon={faEnvelope} className="fa-2x" data-test-id="contact-details-email-icon" />
					<h3 data-test-id="contact-details-email">{email}</h3>
				</>
			)}
		</div>
	);
};

export default ContactDetails;
